import React, { useState, useEffect, useCallback, useRef } from "react";
import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import { useNavigate, useLocation } from "react-router-dom";
import { useLoading } from "../../../context/LoadingContext";
import { getParameterFromManager } from "../../../services/Utils";
import { v4 as uuidv4 } from "uuid";
import DataTable from "../../Requirement/components/common/ReusableTable";
import SearchFilter from "../../Requirement/components/common/SearchFilter";
import AlertModal from "../../Requirement/components/common/AlerModel";
import {
  fetchData,
  postQuery,
} from "../../Requirement/services/RequirementServices";
import {
  FormControl,
  TextField,
  Typography,
  Button,
  Select,
  MenuItem,
} from "@mui/material";

const StrategicPartners = () => {
  const { setLoading } = useLoading();
  const location = useLocation();
  const navigate = useNavigate();
  const [rowStart, setRowStart] = useState(0);
  const [pageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [partners, setPartners] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [activeTab, setActiveTab] = useState("partnerDetails");
  const [countrymaster, setCountryMaster] = useState([]);
  const [names, setNames] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [locations, setLocations] = useState([]);
  const [zipcodes, setZipcodes] = useState([]);
  const [activeUser, setActiveUser] = useState("");
  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    autoClose: null,
  });
  const [searchValues, setSearchValues] = useState({
    searchFirstName: "",
    searchLastName: "",
    searchEmail: "",
    searchCompanyName: "",
    UserType: "StrategicPartner",
  });
  const statusOptions = [
    { value: "", label: "ALL" },
    { value: "ACTIVE", label: "ACTIVE" },
    { value: "INACTIVE", label: "INACTIVE" },
  ];
  const formRef = useRef(null);

  const [formData, setFormData] = useState({
    FirstName: "",
    LastName: "",
    Age: "",
    Gender: "",
    Phone1: "",
    Phone2: "",
    EmailID: "",
    LinkedIn: "",
    Twitter: "",
    Website: "",
    Country: "",
    State: "",
    Address1: "",
    ZipCode: "",
    CompanyName: "",
    CompanyWebsite: "",
    CompanyEmail: "",
    CompanyCountry: "",
    CompanyState: "",
    CompanyAddress1: "",
    CompanyCity: "",
    CompanyZipCode: "",
    CompanyGSTIN: "",
    CompanyLinkedIn: "",
    CompanyTwitter: "",
    CompanyPhone1: "",
    CompanyPhone2: "",
    CompanyPhone3: "",
    CompanyPhone4: "",
    Status: "",
  });

  const [errors, setErrors] = useState({});

  const handleModalClose = () => {
    setModal((prev) => ({ ...prev, show: false }));
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Load countries
  const loadCountries = useCallback(async () => {
    setLoading(true);
    try {
      const [allCountries] = await Promise.all([
        fetchData({
          target: "listDropDownOptions",
          userOrder: "Value",
          rowStart: 0,
          pageSize: 1000,
          filterTerms: { Type: "Country" },
        }),
      ]);
      if (allCountries.items.length > 0) {
        setCountryMaster(allCountries.items);
      } else {
        setCountryMaster([]);
      }
    } catch (error) {
      console.error("Error loading countries: ", error);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const handleChange = (e) => {
    const { name, value } = e.target; // Use name instead of id
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields =
      activeTab === "partnerDetails"
        ? ["FirstName", "LastName", "EmailID", "Country"]
        : ["CompanyName"];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = "This field is required";
      }
    });

    // Email validation
    if (formData.EmailID && !/\S+@\S+\.\S+/.test(formData.EmailID)) {
      newErrors.EmailID = "Invalid email format";
    }
    if (formData.CompanyEmail && !/\S+@\S+\.\S+/.test(formData.CompanyEmail)) {
      newErrors.CompanyEmail = "Invalid email format";
    }

    // Age validation
    if (formData.Age && (isNaN(formData.Age) || formData.Age < 0)) {
      newErrors.Age = "Age must be a positive number";
    }

    console.log("newErrors@@", newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const savePartnerData = async (data) => {
    console.log("data@@", data);
    setLoading(true);
    try {
      const body = isEditMode
        ? {
            target: "updateAMTPLUser",
            updateAMTPLUserInput: {
              AMTPLUserID: data.AMTPLUserID,
              UserType: "StrategicPartner",
              EmailID: data.EmailID || " ",
              GPEmailID: " ",
              FirstName: data.FirstName || "",
              LastName: data.LastName || "",
              Country: data.Country || "",
              State: data.State || "",
              Phone1: data.Phone1 || " ",
              Address1: data.Address1 || " ",
              CompanyName: data.CompanyName || "",
              CompanyZipCode: data.CompanyZipCode || "",
              CompanyGSTIN: data.CompanyGSTIN || "",
              CompanyPhone1: data.CompanyPhone1 || "",
              CompanyAddress1: data.CompanyAddress1 || "",
              CompanyCity: data.CompanyCity || "",
              Status: data.Status || "ACTIVE",
            },
          }
        : {
            target: "createAMTPLUser",
            createAMTPLUserInput: {
              AMTPLUserID: data.AMTPLUserID,
              UserType: "StrategicPartner",
              EmailID: data.EmailID || " ",
              GPEmailID: " ",
              FirstName: data.FirstName || "",
              LastName: data.LastName || "",
              Country: data.Country || "",
              State: data.State || "",
              Phone1: data.Phone1 || " ",
              Address1: data.Address1 || " ",
              CompanyName: data.CompanyName || "",
              CompanyZipCode: data.CompanyZipCode || "",
              CompanyGSTIN: data.CompanyGSTIN || "",
              CompanyPhone1: data.CompanyPhone1 || "",
              CompanyAddress1: data.CompanyAddress1 || "",
              CompanyCity: data.CompanyCity || "",
              Status: data.Status || "ACTIVE",
            },
          };
      console.log("body@@", body);
      const result = await postQuery(body);
      if (result) {
        setModal({
          show: true,
          type: "success",
          title: "Success",
          message: `Strategic Partner ${
            isEditMode ? "updated" : "added"
          } successfully!`,
          autoClose: false,
        });
        await fetchPartners(searchValues);
      }
    } catch (error) {
      console.error("Error saving strategic partner:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: `Failed to ${
          isEditMode ? "update" : "add"
        } strategic partner.`,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      await savePartnerData({
        ...formData,
        AMTPLUserID: isEditMode ? selectedPartner.AMTPLUserID : uuidv4(),
        UserType: "StrategicPartner",
      });
      handleReset();
    }
  };

  const handleReset = () => {
    setFormData({
      FirstName: "",
      LastName: "",
      Age: "",
      Gender: "",
      Phone1: "",
      Phone2: "",
      EmailID: "",
      LinkedIn: "",
      Twitter: "",
      Website: "",
      Country: "",
      State: "",
      Address1: "",
      ZipCode: "",
      CompanyName: "",
      CompanyWebsite: "",
      CompanyEmail: "",
      CompanyCountry: "",
      CompanyState: "",
      CompanyAddress1: "",
      CompanyCity: "",
      CompanyZipCode: "",
      CompanyLinkedIn: "",
      CompanyTwitter: "",
      CompanyPhone1: "",
      CompanyPhone2: "",
      CompanyPhone3: "",
      CompanyPhone4: "",
      Status: "",
    });
    setErrors({});
    setIsEditMode(false);
    setSelectedPartner(null);
    setShowForm(false);
    setActiveTab("partnerDetails");
  };

  const fetchPartners = useCallback(
    async (searchValues, newRowStart = rowStart) => {
      setLoading(true);
      try {
        const body = {
          target: "listAMTPLUsers",
          filterTerms: {
            UserType: "StrategicPartner",
            EmailID: searchValues.searchEmail || "",
            CompanyName: searchValues.searchCompanyName || "",
          },
          rowStart: 0,
          pageSize: 10000, // Large number to fetch all
        };

        const result = await fetchData(body);
        console.log(result, "fetchoption");

        if (result && (result.items || result.statusCode === 200)) {
          const partners = result.items || [];
          if (partners.length > 0) {
            const modifiedItems = (result.items || result).map((item) => ({
              ...item,
              id: item.AMTPLUserID, // Add id property with value from RequirementsID
            }));

            setPartners(modifiedItems);
            setTotalItems(result.total || partners.length);

            const uniqueNames = [
              ...new Set(
                partners
                  .map((p) =>
                    `${p.FirstName || ""} ${p.LastName || ""} <${
                      p.EmailID || ""
                    }>`.trim()
                  )
                  .filter((name) => name !== "<>")
              ),
            ];
            const uniqueCompanies = [
              ...new Set(partners.map((p) => p.CompanyName).filter(Boolean)),
            ];
            const uniqueLocations = [
              ...new Set(partners.map((p) => p.State).filter(Boolean)),
            ];
            const uniqueZipcodes = [
              ...new Set(partners.map((p) => p.ZipCode).filter(Boolean)),
            ];

            setNames(uniqueNames);
            setCompanies(uniqueCompanies);
            setLocations(uniqueLocations);
            setZipcodes(uniqueZipcodes);
          } else {
            setNames([]);
            setCompanies([]);
            setLocations([]);
            setZipcodes([]);
          }
        } else {
          console.error("Error fetching filter options: ", result);
          setNames([]);
          setCompanies([]);
          setLocations([]);
          setZipcodes([]);
        }
      } catch (error) {
        console.error("Error fetching filter options: ", error);
        setNames([]);
        setCompanies([]);
        setLocations([]);
        setZipcodes([]);
      } finally {
        setLoading(false);
      }
    },
    [rowStart, pageSize, setLoading]
  );

  const handleRowClick = (row) => {
    setSelectedPartner(row);
    setIsEditMode(true);
    setShowForm(true);
    setFormData({
      FirstName: row.FirstName || "",
      LastName: row.LastName || "",
      Age: row.Age || "",
      Gender: row.Gender || "",
      Phone1: row.Phone1 || "",
      Phone2: row.Phone2 || "",
      EmailID: row.EmailID || "",
      LinkedIn: row.LinkedIn || "",
      Twitter: row.Twitter || "",
      Website: row.Website || "",
      Country: row.Country || "",
      State: row.State || "",
      Status: row.Status || "",
      Address1: row.Address1 || "",
      ZipCode: row.ZipCode || "",
      CompanyName: row.CompanyName || "",
      CompanyWebsite: row.CompanyWebsite || "",
      CompanyEmail: row.CompanyEmail || "",
      CompanyCountry: row.CompanyCountry || "",
      CompanyState: row.CompanyState || "",
      CompanyAddress1: row.CompanyAddress1 || "",
      CompanyCity: row.CompanyCity || "",
      CompanyZipCode: row.CompanyZipCode || "",
      CompanyGSTIN: row.CompanyGSTIN || "",
      CompanyLinkedIn: row.CompanyLinkedIn || "",
      CompanyTwitter: row.CompanyTwitter || "",
      CompanyPhone1: row.CompanyPhone1 || "",
      CompanyPhone2: row.CompanyPhone2 || "",
      CompanyPhone3: "",
      CompanyPhone4: "",
    });
  };

  useEffect(() => {
    fetchPartners(searchValues);
  }, [fetchPartners, searchValues]);

  useEffect(() => {
    loadCountries();
    if (showForm && formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [showForm, loadCountries]);

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_ADMINS")) {
          await Auth.signOut();
          navigate("/");
        }
        await getParameterFromManager("INR_TO_USD");
      } catch (error) {
        await Auth.signOut();
        navigate("/");
      }
    };

    checkUser();
  }, [navigate]);

  const handlePageChange = (page) => {
    const newRowStart = (page - 1) * pageSize;
    setRowStart(newRowStart);
    fetchPartners(searchValues, newRowStart);
  };

  const handleSearch = (searchTerm) => {
    setSearchValues(searchTerm);
    setRowStart(0);
  };

  const columns = [
    { id: "FirstName", numeric: false, label: "First Name" },
    { id: "LastName", numeric: false, label: "Last Name" },
    { id: "EmailID", numeric: false, label: "Email" },
    { id: "CompanyName", numeric: false, label: "Company Name" },
    { id: "Country", numeric: false, label: "Country" },
    { id: "Status", numeric: false, label: "Status" },
  ];

  const fields = [
    {
      name: "searchEmail",
      label: "Name",
      type: "dropdown",
      options: [
        { value: "", label: "Select Name" },
        ...names.map((name) => {
          const match = name.match(/<([^>]+)>/);
          const keyAndValue = match ? match[1].trim() : "";
          return {
            value: keyAndValue,
            label: name,
          };
        }),
      ],
      value: searchValues.searchEmail,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchEmail: value }));
      },
    },
    {
      name: "searchCompanyName",
      label: "Company",
      type: "dropdown",
      options: [
        { value: "", label: "Select Company" },
        ...companies.map((company) => ({
          value: company,
          label: company,
        })),
      ],
      value: searchValues.searchCompanyName,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, company: value }));
      },
    },
  ];

  return (
    <div className="amtpl-dashboard">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="card">
        <div className="container-fluid">
          <div className="search-filter4">
            <div className="title4">
              <div className="head-text">Strategic Partners</div>
            </div>
            <div className="filter4">
              <SearchFilter fields={fields} onSearch={handleSearch} />
            </div>
            <div
              className="head-btn"
              style={{ display: "flex", gap: "10px", alignItems: "center" }}
            >
              <div
                className="submit-btn"
                onClick={() => {
                  console.log("Add button clicked, setting showForm to true");
                  setShowForm(true);
                  setIsEditMode(false);
                  setFormData({
                    FirstName: "",
                    LastName: "",
                    Age: "",
                    Gender: "",
                    Phone1: "",
                    Phone2: "",
                    EmailID: "",
                    LinkedIn: "",
                    Twitter: "",
                    Website: "",
                    Country: "",
                    State: "",
                    Address1: "",
                    ZipCode: "",
                    CompanyName: "",
                    CompanyWebsite: "",
                    CompanyEmail: "",
                    CompanyCountry: "",
                    CompanyState: "",
                    CompanyAddress1: "",
                    CompanyCity: "",
                    CompanyZipCode: "",
                    CompanyGSTIN: "",
                    CompanyLinkedIn: "",
                    CompanyTwitter: "",
                    CompanyPhone1: "",
                    CompanyPhone2: "",
                    CompanyPhone3: "",
                    CompanyPhone4: "",
                    Status: "",
                  });
                  setErrors({});
                  setActiveTab("partnerDetails");
                }}
              >
                Add
              </div>
            </div>
          </div>
          <DataTable
            columns={columns}
            data={partners}
            total={totalItems}
            title="Strategic Partners List"
            rowsPerPage={pageSize}
            onRowClick={handleRowClick}
            onPageChange={handlePageChange}
            currentPage={Math.floor(rowStart / pageSize) + 1}
            selectedRows={selectedPartner ? [selectedPartner.PartnerID] : []}
          />
          <div className="table-header">
            {showForm && (
              <div className="header-text">
                <div className="head-text">
                  {isEditMode ? "Modify" : "Add"} Strategic Partner
                </div>
              </div>
            )}
            <div className="head-btn">
              {showForm && (
                <>
                  <div onClick={handleSubmit} className="submit-btn">
                    {isEditMode ? "Update" : "Submit"}
                  </div>
                  <div onClick={handleReset} className="submit-btn">
                    {isEditMode ? "Cancel" : "Reset"}
                  </div>
                </>
              )}
            </div>
          </div>

          {showForm && (
            <div className="row ">
              <div className="button-group">
                <Button label="Submit" />
              </div>
              <section>
                <div className="tabs flex border-b">
                  <button
                    className={activeTab === "partnerDetails" ? "active" : ""}
                    onClick={() => handleTabClick("partnerDetails")}
                  >
                    Partner Details
                  </button>
                  <button
                    className={activeTab === "companyDetails" ? "active" : ""}
                    onClick={() => handleTabClick("companyDetails")}
                  >
                    Company Details
                  </button>
                </div>

                {activeTab === "partnerDetails" && (
                  <div className="tab-content active">
                    <div className="row">
                      <div className="col-lg-12 col-sm-12 col-12">
                        <div className="row">
                          <div className="col-lg-3 col-sm-4 col-6">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.FirstName}
                            >
                              <Typography variant="body2">
                                First Name
                              </Typography>
                              <TextField
                                name="FirstName"
                                type="text"
                                value={formData.FirstName || ""}
                                onChange={handleChange}
                                error={!!errors.FirstName}
                                helperText={errors.FirstName}
                                fullWidth
                              />
                            </FormControl>
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.LastName}
                            >
                              <Typography variant="body2">Last Name</Typography>
                              <TextField
                                name="LastName"
                                type="text"
                                value={formData.LastName || ""}
                                onChange={handleChange}
                                error={!!errors.LastName}
                                helperText={errors.LastName}
                                fullWidth
                              />
                            </FormControl>
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.EmailID}
                            >
                              <Typography variant="body2">Email ID</Typography>
                              <TextField
                                name="EmailID"
                                type="email"
                                value={formData.EmailID || ""}
                                onChange={handleChange}
                                error={!!errors.EmailID}
                                helperText={errors.EmailID}
                                InputProps={{
                                  readOnly: isEditMode, // Keep read-only in edit mode
                                }}
                                fullWidth
                              />
                            </FormControl>
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.Phone1}
                            >
                              <Typography variant="body2">Phone</Typography>
                              <TextField
                                name="Phone1"
                                type="text"
                                value={formData.Phone1 || ""}
                                onChange={handleChange}
                                error={!!errors.Phone1}
                                helperText={errors.Phone1}
                                fullWidth
                              />
                            </FormControl>
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.Country}
                            >
                              <Typography variant="body2">Country</Typography>
                              <Select
                                name="Country"
                                value={formData.Country || ""}
                                onChange={handleChange}
                                displayEmpty
                                sx={{ backgroundColor: "white" }}
                                inputProps={{ "aria-label": "Select Country" }}
                                error={!!errors.Country}
                              >
                                <MenuItem value="" disabled>
                                  Select country
                                </MenuItem>
                                {countrymaster.map((p) => (
                                  <MenuItem key={p.ID} value={p.Value}>
                                    {p.Value}
                                  </MenuItem>
                                ))}
                              </Select>
                              {errors.Country && (
                                <Typography variant="caption" color="error">
                                  {errors.Country}
                                </Typography>
                              )}
                            </FormControl>
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.State}
                            >
                              <Typography variant="body2">State</Typography>
                              <TextField
                                name="State"
                                type="text"
                                value={formData.State || ""}
                                onChange={handleChange}
                                error={!!errors.State}
                                helperText={errors.State}
                                fullWidth
                              />
                            </FormControl>
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.Status}
                            >
                              <Typography variant="body2">Status</Typography>
                              <Select
                                name="Status"
                                value={formData.Status || ""}
                                onChange={handleChange}
                                displayEmpty
                                sx={{ backgroundColor: "white" }}
                                inputProps={{ "aria-label": "Select Status" }}
                                error={!!errors.Status}
                              >
                                <MenuItem value="" disabled>
                                  Select Status
                                </MenuItem>
                                <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                                <MenuItem value="INACTIVE">INACTIVE</MenuItem>
                              </Select>
                              {errors.Status && (
                                <Typography variant="caption" color="error">
                                  {errors.Status}
                                </Typography>
                              )}
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "companyDetails" && (
                  <div className="tab-content active">
                    <div className="row">
                      <div className="col-lg-12 col-sm-12 col-12">
                        <div className="row">
                          <div className="col-lg-6 col-sm-8 col-12">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.CompanyName}
                            >
                              <Typography variant="body2">
                                Company Name
                              </Typography>
                              <TextField
                                name="CompanyName" // Use name instead of id
                                type="text"
                                value={formData.CompanyName || ""}
                                onChange={handleChange}
                                error={!!errors.CompanyName}
                                helperText={errors.CompanyName}
                                fullWidth
                              />
                            </FormControl>
                          </div>
                          <div className="col-lg-6 col-sm-8 col-12">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.CompanyPhone1}
                            >
                              <Typography variant="body2">Phone</Typography>
                              <TextField
                                name="CompanyPhone1" // Use name instead of id
                                type="text"
                                value={formData.CompanyPhone1 || ""}
                                onChange={handleChange}
                                error={!!errors.CompanyPhone1}
                                helperText={errors.CompanyPhone1}
                                fullWidth
                              />
                            </FormControl>
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.CompanyAddress1}
                            >
                              <Typography variant="body2">Address</Typography>
                              <TextField
                                name="CompanyAddress1" // Use name instead of id
                                type="text"
                                value={formData.CompanyAddress1 || ""}
                                onChange={handleChange}
                                error={!!errors.CompanyAddress1}
                                helperText={errors.CompanyAddress1}
                                fullWidth
                              />
                            </FormControl>
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.CompanyCity}
                            >
                              <Typography variant="body2">City</Typography>
                              <TextField
                                name="CompanyCity" // Use name instead of id
                                type="text"
                                value={formData.CompanyCity || ""}
                                onChange={handleChange}
                                error={!!errors.CompanyCity}
                                helperText={errors.CompanyCity}
                                fullWidth
                              />
                            </FormControl>
                          </div>

                          <div className="col-lg-3 col-sm-4 col-6">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.CompanyZipCode}
                            >
                              <Typography variant="body2">Zip Code</Typography>
                              <TextField
                                name="CompanyZipCode" // Use name instead of id
                                type="text"
                                value={formData.CompanyZipCode || ""}
                                onChange={handleChange}
                                error={!!errors.CompanyZipCode}
                                helperText={errors.CompanyZipCode}
                                fullWidth
                              />
                            </FormControl>
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.CompanyGSTIN}
                            >
                              <Typography variant="body2">GSTIN</Typography>
                              <TextField
                                name="CompanyGSTIN" // Use name instead of id
                                type="text"
                                value={formData.CompanyGSTIN || ""}
                                onChange={handleChange}
                                error={!!errors.CompanyGSTIN}
                                helperText={errors.CompanyGSTIN}
                                fullWidth
                              />
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </section>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StrategicPartners;
